
export const COLUMNS = [
    {
        Header: "Search",
        accessor: "searchText",
        disableSortBy: true,
    },
    {
        Header: "Order",
        Footer: "Order",
        accessor: "callEndTime",
        disableFilters: true,
        sticky: "left",
    },
    {
        Header: "Distributor",
        Footer: "Distributor",
        accessor: "distributor",
    },
    {
        Header: "Sales Associate",
        Footer: "Sales Associate",
        accessor: "salesassociate",
    },
    {
        Header: "Orders Details",
        Footer: "Orders Details",
        accessor: "orderdetails",
    },
    {
        Header: "Action",
        Footer: "Action",
        accessor: "order_status",
    },
];
